import { useState } from 'react';

import { ConfirmacaoDaAcao } from 'components/task-item/modal-actions/moldura-da-acao';
import TextEditor from 'components/text-editor';

const TITULO = 'Escreva o seu comentário';

/**
 * Tamanho do texto de um comentário já salvo (HTML). O editor só informa o tamanho quando a pessoa digita:
 * sem isto, editar um comentário existente abriria com "Enviar" desligado. `DOMParser` não executa nem
 * carrega nada do conteúdo.
 */
function tamanhoDoTexto(html?: string) {
  if (!html) return 0;
  return new DOMParser().parseFromString(html, 'text/html').body.textContent?.trim().length ?? 0;
}

interface Props {
  sendMessage: (message: string, item: any) => void;
  close: () => void;
  modalCommentObj: any;
  message?: string;
}

/** Comentário num reconhecimento recebido, na moldura dos modais da nova identidade (AJH-19 a AJH-21). */
export default function ModalComment({ sendMessage, close, modalCommentObj, message }: Props) {
  const [value, setValue] = useState(message ?? '');
  const [tamanho, setTamanho] = useState(() => tamanhoDoTexto(message));

  function alterar(conteudo: string, comprimento?: { fullLength: number }) {
    setValue(conteudo);
    setTamanho(comprimento?.fullLength ?? 0);
  }

  const vazio = !value || tamanho < 1;

  return (
    <ConfirmacaoDaAcao
      title={TITULO}
      size="md"
      onClose={close}
      onConfirm={() => !vazio && sendMessage(value, modalCommentObj)}
      confirmLabel="Enviar"
      confirmDisabled={vazio}
    >
      <div className="h-[250px]">
        <TextEditor appearance="light" ariaLabel={TITULO} initialValue={message} onChange={alterar} />
      </div>
    </ConfirmacaoDaAcao>
  );
}
